import React, {useState, useEffect} from 'react'
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { makeStyles } from '@mui/styles';
import './Privacy.scss'
import chromo from '../../assets/chromo.svg' 
import arrow from '../../assets/right-down.png' 
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getAllPreferencesPrivacy, getDataProfileFB, updatePrivacyUserPreferences } from '../../functions'
import styled from '@emotion/styled';
import { URL_EXTENSION } from '../../utils/constant_data';
import Footer from '../../components/Footer/Footer';
import ModalPrivacy from '../../components/ModalPrivacy/ModalPrivacy';


const Privacy = (props) => {
    const [dataMode, setDataMode] = useState([])
    const [txtButton, setTxtButton] = useState(null)
    const [open, setOpen] = useState(false)
    const [name, setName] = useState(null)
    const [about, setAbout] = useState(null)

    useEffect(() => {
        getPrefsPrivacity()
    }, [])

    const getPrefsPrivacity = async () => {

        const response = await getAllPreferencesPrivacy();
        const responseUser = await getDataProfileFB()
        if(response && response.result) {
            if(responseUser && responseUser.result) {
                let arrayData = response.result.map( dp => {
                    let prefsPriv = responseUser.result.preferences_privacity.filter(dtp => {
                        if(dp.id === dtp.id) {
                            return dtp
                        }
                    })
                    return {
                        ...dp,
                        preferences_privacity: prefsPriv[0]
                    }
                })
                setDataMode([...arrayData]);
            }
        }

    }

    const goToExtension = () => {
        window.location.assign(URL_EXTENSION)
    }

    console.log(dataMode)

    const useStyles = makeStyles({
        root: {
            background: 'white',
            border: 0,
            borderRadius: 20,
            position: 'absolute',
            top: window.innerWidth > 700 ? '25%' : "25%",
            left: window.innerWidth > 700 ? '30%' : "2%",
            right: window.innerWidth > 700 ? '30%' : "2%",
            color: 'white',
            padding: ' 15px 30px',
        },
        rootAge: {
            background: 'white',
            border: 0,
            borderRadius: 50,
            position: 'absolute',
            top: window.innerWidth > 700 ? '30%' : "25%",
            left: window.innerWidth > 700 ? '28%' : "2%",
            right: window.innerWidth > 700 ? '28%' : "2%",
            color: 'white',
            padding: '2%',
        },
        rootPrivacy: {
            background: 'white',
            border: 0,
            borderRadius: 20,
            position: 'absolute',
            top: window.innerWidth > 700 ? '30%' : "25%",
            left: window.innerWidth > 700 ? '35%' : "2%",
            right: window.innerWidth > 700 ? '35%' : "2%",
            color: 'white',
            padding: '1%',
        }
    });

    const classes = useStyles();

    return (
        <div className='privacy'>
            <h1>Privacidad.</h1>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={classes.rootPrivacy}>
                    <ModalPrivacy name={name} about={about}  />
                </Box>
            </Modal>

            <div className='privacy_info'>
                <div className='privacy_info_first'>
                    <p>Selecciona las cookies que desea <b style={{ fontWeight: 400, color: '#68bbe3' }}>bloquear</b></p>
                    <p>Si quiere más información sobre cada tipo de</p>
                    <p>cookie, cliquea en el icono correspondiente</p>
                </div>
                <div className='privacy_info_second'>
                    <p>Se necesita descargar la extensión de</p>
                    <p>chrome para ver los cambios.</p>
                    <img src={arrow} />
                </div>
                <button onClick={goToExtension}>
                    <img src={chromo} />
                    Añadir a Chrome
                </button>
            </div>

            <div className='privacy_content'>
                {
                    dataMode && dataMode.length > 0 ?
                    dataMode.map(dt => (
                        <RenderItemPrivacy key={dt.id} data={dt} dataMode={dataMode} setName={setName} setAbout={setAbout} setOpen={setOpen} />
                    )) : null
                }
            </div>

            <Footer />
        </div>
    )
}

// Get privacy preferences
function getDataMode(prefs) {
    return prefs.map( pref => {
        return {
            ...pref.preferences_privacity
        }
    })
}

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 60,
    height: 30,
    padding: 0,
    marginTop: 0,
    borderRadius: 20,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(30px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#68bbe3',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: 'grey',
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
      marginTop: 2,
      marginLeft: 2,
    },
    
  }));

// Function to render item privacy
function RenderItemPrivacy(props) {

    const { data, dataMode, setName, setAbout, setOpen } = props
    const { id, image_url, preferences_privacity, name, about } = data

    const handleOnChange = async e => {
        
        let arrayDataMode = dataMode.map(dm => {
            if(dm.id === id) {
                dm.preferences_privacity.active = !dm.preferences_privacity.active
            }
            return dm;
        })

        let finalDataMode = getDataMode(arrayDataMode);

        const response = await updatePrivacyUserPreferences(finalDataMode);
        if(response && response.error) {
            toast.error('Ha ocurrido un error al actualizar su información, por favor pruebe de nuevo')
        }
    }

    const openModalWithParams = () => {
        setName(name)
        setAbout(about)
        setOpen(true)
    }

    return (
        <div className='privacy_content_item'>
            <img src={image_url} onClick={openModalWithParams}/>
            <h2>{name}.</h2>
            <IOSSwitch sx={{ m: 1 }} onChange={handleOnChange} defaultChecked={preferences_privacity.active ? true : false} />
        </div>
    )

}



export default withRouter(Privacy)